const mediaData = [
  {
    title: '91免费看片 V8.2 功能全面解析',
    desc: '带你了解最新版91免费看片的app的全部新功能与使用技巧',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20player%20interface%20on%20a%20tablet%20screen%20with%20movie%20posters%20and%20control%20buttons%2C%20placed%20on%20a%20clean%20desk%20with%20notebook%20and%20coffee%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20review%20setup%2C%20editorial%20photography%20style&width=960&height=540&seq=media-video-01&orientation=landscape',
    duration: '08:32',
    views: '12.6万',
  },
  {
    title: '手机免费看片软件安装全流程演示',
    desc: '从下载到安装再到首次使用的完整视频指引',
    img: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20app%20installation%20process%20with%20progress%20bar%2C%20placed%20on%20a%20minimal%20desk%20with%20cables%20and%20accessories%2C%20bright%20clean%20workspace%2C%20soft%20natural%20light%2C%20product%20demonstration%20style&width=960&height=540&seq=media-video-02&orientation=landscape',
    duration: '05:16',
    views: '8.3万',
  },
  {
    title: '91免费客户端 vs 同类软件深度对比',
    desc: '从画质、流畅度、资源量三个维度横向对比',
    img: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20displaying%20different%20video%20apps%20interfaces%20for%20comparison%2C%20clean%20white%20surface%2C%20minimal%20setup%2C%20professional%20comparison%20review%20layout%2C%20bright%20studio%20lighting&width=960&height=540&seq=media-video-03&orientation=landscape',
    duration: '12:45',
    views: '5.9万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选视频</h2>
          <p className="mt-2 text-sm text-foreground-500">91免费看片软件使用教程与功能展示</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded-md font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}